import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Fullscreen image viewer. Shows the full image (object-contain, nothing cut)
// and lets you swipe/arrow through multiple images. Pass index=null to close.
export default function ImageLightbox({ images = [], index = null, onClose }) {
  const open = index !== null && index >= 0 && images.length > 0;
  const [i, setI] = useState(index || 0);

  useEffect(() => {
    if (index !== null && index >= 0) setI(index);
  }, [index]);

  const n = images.length;
  const go = (d) => (e) => { e.stopPropagation(); setI((p) => (p + d + n) % n); };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent
        className="w-[96vw] max-w-4xl p-2 rounded-2xl bg-slate-900 border-0 [&>button]:text-white [&>button]:opacity-90 hover:[&>button]:opacity-100"
        data-testid="image-lightbox"
      >
        <DialogHeader className="sr-only"><DialogTitle>Foto offerta</DialogTitle></DialogHeader>
        <div className="relative flex items-center justify-center">
          {open && (
            <img
              src={images[i]}
              alt="Foto offerta"
              className="w-full h-auto max-h-[85vh] object-contain rounded-xl"
              data-testid="image-lightbox-img"
            />
          )}
          {n > 1 && (
            <>
              <button onClick={go(-1)} data-testid="lightbox-prev" aria-label="Precedente"
                className="absolute left-2 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-black/50 hover:bg-black/70 text-white flex items-center justify-center transition-colors">
                <ChevronLeft className="h-6 w-6" />
              </button>
              <button onClick={go(1)} data-testid="lightbox-next" aria-label="Successiva"
                className="absolute right-2 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-black/50 hover:bg-black/70 text-white flex items-center justify-center transition-colors">
                <ChevronRight className="h-6 w-6" />
              </button>
              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 px-2.5 py-1 rounded-full bg-black/60 text-white text-xs font-semibold">
                {i + 1} / {n}
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
